
document.addEventListener('DOMContentLoaded', function () {
    if (typeof GLightbox != 'undefined') {
        const lightbox = GLightbox({
            touchNavigation: true,
            loop: true
        });
    }
});
